import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import { MARGIN_GAP } from "../../../lib/constants.js";
import { useTheme } from "@emotion/react";

export default function Login({
  handleSubmit,
  locales,
  onChangeUsername,
  onChangePassword,
}) {
  const { palette } = useTheme();

  return (
    <Container
      sx={{
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
      <Paper
        id="login"
        sx={{
          boxShadow: `0 0 5px ${palette.divider}`,
          gap: MARGIN_GAP,
          maxWidth: "300px",
          p: 2,
          textAlign: "center",
        }}
      >
        <Box id="login-fields">
          <TextField
            color="secondary"
            fullWidth
            label={locales["home.login.username"]}
            margin="normal"
            onChange={onChangeUsername}
            sx={{
              "& .MuiFilledInput-root": {
                backgroundColor: "backgroundContrast.main",
              },
              "& .MuiInputBase": {
                backgroundColor: "backgroundContrast.main",
              },
            }}
            variant="filled"
          />
          <TextField
            color="secondary"
            fullWidth
            label={locales["home.login.password"]}
            margin="normal"
            onChange={onChangePassword}
            sx={{
              "& .MuiFilledInput-root": {
                backgroundColor: "backgroundContrast.main",
              },
              "& .MuiInputBase": {
                backgroundColor: "backgroundContrast.main",
              },
            }}
            type="password"
            variant="filled"
          />
        </Box>
        <Button
          color="secondary"
          onClick={handleSubmit}
          size="large"
          sx={{ mt: 4 }}
          variant="outlined"
        >
          {locales["home.login.button"]}
        </Button>
      </Paper>
    </Container>
  );
}
